import React, { PureComponent } from 'react';
import defaultSettings from './settings';
import PackageSelectionPrompt from '../../components/PackageSelectionPrompt';
import { getOnboardingProps } from './utils';
import {
    GA_COPY_MESSAGE_VIEW_ACTION,
    GA_COPY_NON_ADMIN_MESSAGE_VIEW_ACTION,
    GA_CREATE_MESSAGE_VIEW_ACTION,
    GA_CREATE_NON_ADMIN_MESSAGE_VIEW_ACTION,
    GA_LABEL,
    GA_MIGRATION_CATEGORY,
} from '../../constants/analytics';

import { Modal } from '@eventbrite/eds-modal';

export default class OnboardingPage extends PureComponent {
    componentDidMount() {
        const {
            isCreate,
            isCopy,
            canAccessLegacyConvert,
            locale,
            userId,
            trackEvent,
        } = this.props;
        let eventData = null;

        // If legacy user is parent user
        if (isCreate && !canAccessLegacyConvert) {
            eventData = {
                action: GA_CREATE_MESSAGE_VIEW_ACTION,
                label: GA_LABEL,
                category: GA_MIGRATION_CATEGORY,
                userId,
            };
        } else if (isCopy && !canAccessLegacyConvert) {
            eventData = {
                action: GA_COPY_MESSAGE_VIEW_ACTION,
                label: GA_LABEL,
                category: GA_MIGRATION_CATEGORY,
                userId,
            };
        }

        if (isCreate && canAccessLegacyConvert) {
            eventData = {
                action: GA_CREATE_NON_ADMIN_MESSAGE_VIEW_ACTION,
                label: GA_LABEL,
                category: GA_MIGRATION_CATEGORY,
                userId,
            };
        } else if (isCopy && canAccessLegacyConvert) {
            eventData = {
                action: GA_COPY_NON_ADMIN_MESSAGE_VIEW_ACTION,
                label: GA_LABEL,
                category: GA_MIGRATION_CATEGORY,
                userId,
            };
        }

        if (eventData) {
            trackEvent(eventData);
        }
    }

    render() {
        const { referer, redirectToReferer } = this.props;
        const { onboardingPrompt, onPrimaryCTAClick } = getOnboardingProps(
            this.props,
            defaultSettings,
        );
        const modalAnimOverrideClassName = {
            __className: 'marketing-modal--no-anim',
        };

        return (
            <div>
                <div className="marketing-modal__container" />
                <Modal
                    type="complex"
                    isShown={true}
                    onClose={redirectToReferer.bind(this, referer)}
                    dangerouslySetContainerClassName={
                        modalAnimOverrideClassName
                    }
                >
                    <PackageSelectionPrompt
                        {...onboardingPrompt}
                        onPrimaryCTAClick={onPrimaryCTAClick}
                    />
                </Modal>
            </div>
        );
    }
}
